import axios from "axios";

export const getSlides = ({ uen, language }) => {
  const requestUrl = `/data/slides`;

  let params = {
    uen: uen,
    language: language
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getDashboardMetadata = ({ id, uen, status }) => {
  const requestUrl = `/data/dashboard/metadata`;

  let params = {
    id: id,
    uen: uen,
    status: status
  };
  return axios.get(requestUrl, {
    params
  });
};

export const saveDashboardComposition = ({
  uen,
  dashboardId,
  labels,
  slidesOrder,
  status,
  isPublic,
  isEditable
}) => {
  const requestUrl = `/data/compose/dashboard`;

  let formData = new FormData();
  formData.append("uen", uen);
  dashboardId && formData.append("dashboardId", dashboardId);
  formData.append("labels", JSON.stringify(labels));
  formData.append("slidesOrder", JSON.stringify(slidesOrder));
  formData.append("status", status);
  formData.append("isPublic", isPublic);
  formData.append("isEditable", isEditable);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/dashboardComposition.js